import { Tabs } from "antd";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserPermissions } from "~context/UserPermissionsContext";
import { PermissionOperations } from "~enums/permissions.ts";
import type { TabRoute } from "../types/TabRoute.ts";

type Props = {
  routes: TabRoute[];
  baseUrl: string;
};
export const NavTabs = ({ routes, baseUrl }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasPermission } = useUserPermissions();

  const activeKey = routes.find((r) => location.pathname.endsWith(`/${r.path}`))?.key ?? routes[0]?.key;
  const navigateToRoute = (key: string) => {
    const route = routes.find((r) => r.key === key);
    if (!route) throw new Error("Route not found");
    navigate(`${baseUrl}/${route.path}`);
  };

  const filteredTabRoutes = useMemo<TabRoute[]>(
    () => routes.filter(({ permissionKey }) => hasPermission(permissionKey, PermissionOperations.READ)),
    [routes, hasPermission],
  );
  return <Tabs className="tabs-wrap" onChange={navigateToRoute} items={filteredTabRoutes} activeKey={activeKey} />;
};
